<template>
  <div class="container">
    <div class="sites-container">
      <div class="sites-wrapper">
        <div
          v-for="(item, index) in dropdown"
          :key="index"
          class="site"
          @mouseover="showBox = index"
          @mouseleave="showBox = ''"
        >
          {{item.title}}
<!--          <span class="iconfont">&#xe602;</span>-->
          <div v-show="index === showBox" class="sub-sites">
            <ul>
              <li v-for="(site, index2) in item.list" :key="index2" :title="site.title" @click="toSite(site.url)">
                <span class="iconfont">
                  <img :src="logo" alt="">
                </span>
                {{site.title}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-container">
      <div class="wrapper">
        <div class="left">
<!--          <ul>-->
<!--            <li>-->
<!--              <a href="#">办公OA</a>-->
<!--            </li>-->
<!--            <li class="line"></li>-->
<!--            <li>-->
<!--              <a href="#">公司介绍</a>-->
<!--            </li>-->
<!--            <li class="line"></li>-->
<!--            <li>-->
<!--              <a href="#">网站地图</a>-->
<!--            </li>-->
<!--            <li class="line"></li>-->
<!--            <li>-->
<!--              <a href="#">互动交流</a>-->
<!--            </li>-->
<!--            <li class="line"></li>-->
<!--            <li>-->
<!--              <a href="#">版权声明</a>-->
<!--            </li>-->
<!--            <li class="line"></li>-->
<!--            <li>-->
<!--              <a href="#">法律声明</a>-->
<!--            </li>-->
<!--          </ul>-->
            <div class="address-div">
              <p class="address">
                地址：成都市青羊区金泽路1号川煤华荣能源公司
              </p>
<!--              <p class="address">-->
<!--                电话：028-87067387-->
<!--              </p>-->
<!--              <p class="address">-->
<!--                邮编：610091-->
<!--              </p>-->
              <p class="address">
                信访联系电话：02861358139
              </p>
              <p class="address" id="link" @click="openWin">
              蜀ICP备2021013200号
              </p>
            </div>

        </div>

<!--        <div class="qr-code">-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/lj.png'
export default {
  name: 'GlobalBottom',
  data () {
    return {
      logo:logo,
      dropdown: [
        {
          title: '政府网站',
          list: [
            {
              title: '中国政务网',
              url: 'http://www.gov.cn/'
            },
            {
              title: '中国国家能源局',
              url: 'http://www.nea.gov.cn/'
            },
            {
              title: '四川省人民政府',
              url: 'http://www.sc.gov.cn/'
            },
            {
              title: '四川省纪委监委网',
              url: 'http://www.scjc.gov.cn/'
            },
            {
              title: '四川省应急管理厅',
              url: 'https://yjt.sc.gov.cn/'
            },
            {
              title: '国务院国资委',
              url: ' http://www.sasac.gov.cn/'
            },
            {
              title: '四川国资委网站',
              url: '  http://gzw.sc.gov.cn/'
            },
          ]
        },
        {
          title: '集团网站群',
          list: [
            {
              title: '川煤集团',
              url: 'http://www.cmjt.com.cn'
            },
            {
              title: '鼎能房产',
              url: 'http://www.scdnfc.com/'
            },
            {
              title: '川煤六建',
              url: 'http://cmlj.scdnjt.com/'
            },

          ]
        },
        {
          title: '新闻媒体',
          list: [
            {
              title: '人民日报',
              url: 'http://www.people.com.cn/'
            },
            {
              title: '中国青年报',
              url: 'http://zqb.cyol.com/html/2020-12/01/nbs.D110000zgqnb_01.htm'
            },
            {
              title: '中国法制报',
              url: 'http://www.legaldaily.com.cn/'
            },
            {
              title: '中国能源报',
              url: 'http://paper.people.com.cn/zgnyb/html/2020-06/01/node_2222.htm'
            },
            {
              title: '中国煤炭报',
              url: 'http://www.ccoalnews.com/'
            },

          ]
        }
      ],
      showBox: ''
    }
  },
  methods: {
    toSite (url) {
      window.open(url)
    },
    openWin(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  }
}
</script>

<style scoped>
.container{

}
.iconfont img{
  width: 10px;
  height: 10px;
}
.sites-container {
  width: 100%;
  height: 100px;
  background-color: #585858;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sites-wrapper {
  width: 1290px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.site {
  width: 312px;
  color: #ffffff;
  box-sizing: border-box;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border: 2px solid #ffffff;
  font-size: 14px;
}

.sub-sites {
  position: absolute;
  top: 34px;
  left: -2px;
  background-color: #A4A4A4;
  z-index: 999;
  box-sizing: border-box;
}

.sub-sites ul {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sub-sites ul li {

  width: 45%;
  padding: 3px 3px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  list-style: none;
}

.sub-sites ul li:hover {
  color: #A9E2F3;
  cursor: pointer;
}

.bottom-container {
  height: 93px;
  width: 100%;
  padding: 0 10px;
  background-color: #585858;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.wrapper {

  text-align: center;
  width: 1290px;
  height: 60px;
  display: flex;
  justify-content: space-between;
}

.left {
  position: relative;
  top: -40px;
  margin: 0 auto;
  width: 50%;
  font-size: 14px;
}

.left ul {
  list-style-type: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.left .line {
  height: 12px;
  width: 1px;
  background-color: #fff;
}

.left a {
  color: #ffffff;
  text-decoration: none;
}

.left p {
  color: #ffffff;
  font-size: 14px;
}
.qr-code img {
  height: 100px;
}
#link:hover{
  color: #66b1ff;
  cursor: pointer;
}
.address-div {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/End-text.vue